<template>
  <div ref="el" :class="[$style.base, { [$style.isTouch]: device.touch }]">
    <div
      :class="$style.inner"
      :style="
        isActive
          ? {
              'background-color': widgetSettings.color,
              color: 'white'
            }
          : {}
      "
      @click="onClick"
      v-test="'category-item'"
    >
      {{ data.id ? data.name : $t('services.top_services') }}
    </div>
  </div>
</template>

<script setup lang="ts">
import type { ServiceCategory, ServiceVariationGroupCategory } from '@/types';
import { device } from '@/user-context';
import widgetSettings from '@/widget-settings';
import { computed, inject, ref, watch } from 'vue';

const props = defineProps<{
  data: ServiceCategory | ServiceVariationGroupCategory;
}>();

const emit = defineEmits(['select', 'scrollTo']);
const gtag = inject<any>('gtag');
const mixpanel = inject<any>('mixpanel');
const selectedCategoryId = inject<any>('selectedCategoryId');

const isActive = computed(() => selectedCategoryId.value === props.data.id);

const el = ref();

watch(isActive, (value) => {
  if (value) {
    emit('scrollTo', el.value.offsetLeft);
  }
});

const onClick = () => {
  emit('select', props.data.id);
  mixpanel.track('service_category_select');

  gtag.trackEvent('service_category_select', {
    category_id: props.data.id
  });
};
</script>

<style lang="scss" module>
.base {
  &.isTouch {
    padding-left: $spacing;

    &:last-child {
      padding-right: $spacing;
    }
  }

  &:not(.isTouch) {
    padding-left: 3px;

    &:last-child {
      padding-right: 3px;
    }

    &:not(:last-child) {
      padding-right: $spacing - 3px;
    }
  }
}

.inner {
  padding: 12px 18px;
  font-size: 12px;
  font-weight: bold;
  white-space: nowrap;
  border-radius: 20px;
  cursor: pointer;
  @include box-shadow;
}
</style>
